import { ELocale, DomainTranslations } from 'App/i18n/i18n.types';

import Domain from 'commons/utils/domains';

import ptBR from './balance.pt-BR.json';

const balanceTranslations: DomainTranslations = {
  name: Domain.BALANCE,
  languages: {
    [ELocale.ARGENTINA]: {},
    [ELocale.MEXICO]: {},
    [ELocale.BRAZIL]: ptBR
  }
};

export default balanceTranslations;
